import { QueryClient } from '@tanstack/react-query';

let browserQueryClient: QueryClient | null = null;

function createQueryClient(): QueryClient {
    return new QueryClient({
        defaultOptions: {
            queries: {
                // We do not want navigation to show cached (potentially stale) data.
                // Role switching also changes authorization context, so caches must not linger.
                staleTime: 0,
                // Drop inactive queries immediately on unmount so that page navigation always reloads.
                gcTime: 0,
                refetchOnMount: 'always',
                refetchOnReconnect: 'always',
                // Window focus refetch is noisy; navigation/role-switch already covers correctness.
                refetchOnWindowFocus: false,
                retry: 1,
            },
        },
    });
}

export function getQueryClient(): QueryClient {
    if (!browserQueryClient) {
        browserQueryClient = createQueryClient();
    }

    return browserQueryClient;
}
